import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from '../hooks/useCurrentUser';

/**
 * Frontend gate for /admin/* routes. The backend AdminGuard is the
 * authoritative check — this wrapper just avoids rendering the page
 * shell + firing API calls for users who would be rejected anyway.
 *
 * Anyone not logged in goes to the landing page; logged-in non-staff
 * users get bounced to /app (their workspace home).
 */
export function AdminRoute({ children }: { children: ReactNode }) {
  const { data: user, isLoading } = useCurrentUser();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-ink-500">
        …
      </div>
    );
  }
  if (!user) {
    return <Navigate to={`/?auth=required&next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (!user.isPlyEZStaff) {
    return <Navigate to="/app" replace />;
  }
  return <>{children}</>;
}
